// utils.js
export const getCurrentDate = () => {
  const now = new Date()
  return now
    .toISOString()
    .replace("Z", "") // Remove the 'Z' at the end
    .replace("T", " ") // Replace the 'T' with a space for date-time format
}

export const indexTemplate = (rowData, options) => {
  return options.rowIndex + 1
}

export const sessionData = () => {
  return Date.now() // Current timestamp in milliseconds
}
export const getCustomISODate = () => {
  return new Date().toISOString().replace(/\.\d{3}Z$/, "Z")
}

// utils/formatters.js
// utils/formatters.js
export const formatDisplayList = (list = [], key = "") => {
  if (!Array.isArray(list) || list.length === 0) return "-"

  if (typeof list[0] === "string") {
    return (
      list
        .map((item) =>
          item.replaceAll("_", " ").replaceAll(/\b\w/g, (c) => c.toUpperCase()),
        )
        .join(", ") || "-"
    )
  }

  if (key && typeof list[0] === "object") {
    return (
      list
        .map((item) => item[key])
        .filter(Boolean)
        .join(", ") || "-"
    )
  }

  return "-"
}
